import type { ResponseMessage } from '@kiddocare-platform/portal-common/base'
import type { Illness, Vaccination, VisitType, Medicine, DiaryType, GrowthMeasure, Beverage } from '@kiddocare-platform/portal-common/family'
import type { CacheEntry } from '../../entry.cache'

export interface FamilyCacheState {
  visitTypes: CacheEntry<ResponseMessage<Array<VisitType>>> | undefined
  medicines: CacheEntry<ResponseMessage<Array<Medicine>>> | undefined
  illnesses: CacheEntry<ResponseMessage<Array<Illness>>> | undefined
  beverages: CacheEntry<ResponseMessage<Array<Beverage>>> | undefined
  vaccines: Record<string, CacheEntry<ResponseMessage<Array<Vaccination>>>>
  diaryTypes: Record<string, CacheEntry<ResponseMessage<Array<DiaryType>>>>
  diaryType: Record<string, CacheEntry<ResponseMessage<DiaryType>>>
  growthMeasures: Record<string, CacheEntry<ResponseMessage<GrowthMeasure>>>
}

export const getInitialFamilyCacheState = (): FamilyCacheState => ({
  visitTypes: undefined,
  medicines: undefined,
  illnesses: undefined,
  beverages: undefined,
  vaccines: {},
  diaryTypes: {},
  diaryType: {},
  growthMeasures: {},
})
